<script lang="ts">
  import { defineComponent } from "vue";
  import FicheAttestationCompte from '@/generated/fiches/FicheAttestationCompte.vue';
  export default defineComponent({
    extends: FicheAttestationCompte,
    components: {}
})
</script>
